import {Grid} from "@mui/material";
import {useAppSelector} from "../../../Config/Hooks";
import TransformerTemperatureChart from "./TransformerTemperatureChart/TransformerTemperatureChart";
import GenerationEnergySkidChart from "./GenerationEnergySkidChart/GenerationEnergySkidChart";
import ActivePowerInvertersSkidChart from "./ActivePowerInverterSkidChart/ActivePowerInvertersSkidChart";
import PowerPUForInvertersChart from "./PowerPUForInvertersChart/PowerPUForInvertersChart";
import GenerationRateOfInvertersChart from "./GenerationRateOfInvertersChart/GenerationRateOfInvertersChart";
import ErrorBoundaryChart from "../../../Shared/Error/ErrorBoudaryChart"
import { ASectionTitle } from "@atiautomacao/ati-ui-library";

export default function DashboardPowerPlantSkidChartsPage(){

    const {selectedPowerPlant, selectedSkid} = useAppSelector((state) => state.dashboard);

    return(
        <Grid container spacing={'24px'} paddingLeft={'24px'} paddingRight={'24px'} paddingBottom={'24px'}>
            <Grid item xs={12} style={{paddingRight: 24}}>
                <ASectionTitle 
                    titleLabel={selectedSkid.name}
                    styleContainer={{ padding: '8px 0px 0px' }}
                />
            </Grid>
             <Grid item xs={12} lg={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Potência de Inversores"}>
                    <ActivePowerInvertersSkidChart skidId={selectedSkid.id}/>
                </ErrorBoundaryChart>
            </Grid>
            <Grid item xs={12} lg={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Temperatura do Transformador"}>
                    <TransformerTemperatureChart powerPlant={selectedPowerPlant.id} skidId={selectedSkid.id}/>
                </ErrorBoundaryChart>
            </Grid>
            <Grid item xs={12} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Potência por inversor (PU)"}>
                    <PowerPUForInvertersChart skid={selectedSkid}/>
                </ErrorBoundaryChart>
            </Grid>
           
            <Grid item xs={12} lg={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Energia Gerada vs Injetada"}>
                    <GenerationEnergySkidChart powerPlant={selectedPowerPlant.id} skid={selectedSkid.id}/>
                </ErrorBoundaryChart>
            </Grid>
            <Grid item xs={12} lg={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Taxa de Geração"}>
                    <GenerationRateOfInvertersChart skidId={selectedSkid.id}/>
                </ErrorBoundaryChart>
            </Grid>
        </Grid>
    );
}
